import _ from 'lodash';
import { useMediaQuery } from 'react-responsive';
import theme from '../../../../assets/stylesheets/_settings.global.scss';

export default function commonProps() {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const isMobile = useMediaQuery({ query: `(max-width: ${theme.breakpointMediumMax})` });
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const isXLarge = useMediaQuery({ query: `(min-width: ${theme.breakpointXlargeMin})` });
  const profile = _.get(window, 'Livewire.currentUser.profile');
  const isUserSignedIn = !!(_.get(profile, 'firstName'));

  return {
    ...theme,
    isMobile,
    isXLarge,
    isUserSignedIn,
  };
}
